import cornerCabinet from './cornerCabinet.json';
import roundedCabinet from './roundedCabinet.json';

export { cornerCabinet, roundedCabinet };
